import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import ConsultaResumen from './steps/ConsultaResumen';
import PacienteSelector from './steps/PacienteSelector';
import ConsultaPaciente from './steps/ConsultaPaciente';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
}));

const RecetarioStep = ({ isLoaded }) => {

  const { data: dataCliente } = useSelector(
    (state) => state.data_clientes
  );

  const { id: idCliente } = dataCliente;

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = ['Paciente', 'Consulta', 'Resumen'];
  const [medidasCliente, setmedidasCliente] = React.useState({
    peso: '',
    talla: '',
    pa: '',
    cie: '',
    imc: '',
  });

  const [cie10, setCie10] = useState([]);
  const [alergias, setAlergias] = useState('');
  const [medicinas, setMedicinas] = useState([]);

  const [receta, setReceta] = useState(null);
  const [IdCliente, setIdCliente] = useState('');


  const handleNext = () => {

    if (activeStep === 0) {
      // Cliente
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    } else if (activeStep === 1) {
      // Consulta
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    } else if (activeStep === 2) {
      // Resumen
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  useEffect(() => {
    if (isLoaded && idCliente) setIdCliente(idCliente);
  }, [isLoaded, idCliente])


  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <div
              style={{
                margin: '50px auto',
                display: 'flex',
                flex: '1',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography className={classes.instructions}>Se ha reservado la cita</Typography>
              <CheckCircleIcon fontSize="large" htmlColor="green" />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button onClick={handleReset}>Nueva reserva</Button>
            </div>
          </div>
        ) : (
          <div>
            {activeStep === 0 && (
              <PacienteSelector setIdCliente={val => setIdCliente(val)} onClick={handleNext} isLoaded={isLoaded} />
            )}

            {activeStep === 1 && (
              <ConsultaPaciente
                cliente_id={IdCliente}
                handleClickNext={handleNext}
                handleBack={handleBack}
                handleSetMedidas={param => setmedidasCliente(param)}
                handleSetCie10={setCie10}
                handleSetAlergias={setAlergias}
                handleSetMedicinas={setMedicinas}
                setReceta={setReceta}
              />
            )}
            {activeStep === 2 && <ConsultaResumen receta={receta} medidas={medidasCliente} medicinas={medicinas} cie10={cie10} alergias={alergias} />}

          </div>
        )}
      </div>
    </div>
  );
};

export default RecetarioStep;
